import { Injectable } from '@angular/core';
import { BaseClientService } from '../../../core/services/base-client.service';
import { HttpClient } from '@angular/common/http';
import { RolesModel, UserModel } from '../models/users.model';
import { SelectModel } from '../../../core/models/select.mode';
import { lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserService extends BaseClientService<UserModel> {

  constructor(httpClient: HttpClient) {
    super('users', httpClient);
  }

  getRoles(roles: RolesModel[], isRtl: boolean): SelectModel[] {
    return roles?.map(roles => ({
      key: roles.id,
      name: isRtl ? roles.nameAr : roles.name
    }));
  }

  getUsers(user: UserModel[]): SelectModel[] {
    return user?.map(user => ({
      key: user.id,
      name: user.fullname
    }));
  }

  getCurrentUser() {
    return this.get<UserModel>('current');
  }

  async getAgentByProject(projectId: number): Promise<UserModel[]> {
    return await lastValueFrom(this.get<UserModel[]>('agent-project/' + projectId));
  }
}
